import { useContext } from 'react'
import { AuthContext, IAuthContextType } from './AuthContext'

export const useAuth = (): IAuthContextType => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
